export default __webpack_public_path__ + "static/Wizard_08-d94bf070b4857f507f851a0f037a9299.webp";